import { render, staticRenderFns } from "./EmployerMatchTrueUpRadio.vue?vue&type=template&id=aa2b7a24&"
import script from "./EmployerMatchTrueUpRadio.vue?vue&type=script&lang=js&"
export * from "./EmployerMatchTrueUpRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports